<template>
  <div class="level-care-wrap public_bg">
    <div class="nurse_top">
      <div style="height:54px;line-height:54px;">
        <img style="vertical-align:middle;" src="@/assets/beadhouse/juxing.png" alt="" />
        <span>自理等级</span>
      </div>
    </div>
    <div class="toolbar">
      <el-button type="primary" icon="el-icon-plus" plain @click="openAdd">新增</el-button>
      <el-button type="default" icon="el-icon-refresh" plain @click="loadList">刷新</el-button>
    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      border
      style="width: 100%"
      :header-cell-style="tableHeaderStyle"
      :cell-style="{ textAlign: 'center' }"
    >
      <el-table-column prop="id" label="编号" width="90" />
      <el-table-column prop="nursingCare" label="自理/护理等级" min-width="140" />
      <el-table-column prop="nursingProject" label="护理项目" min-width="140" />
      <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip />
      <el-table-column label="操作" width="160" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="openEdit(scope.row)">编辑</el-button>
          <el-button type="text" size="small" style="color:#f56c6c" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="fenye"
      background
      layout="total, prev, pager, next"
      :total="total"
      :page-size="pageSize"
      :current-page.sync="pageNum"
      @current-change="loadList"
    />

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="480px"
      :close-on-click-modal="false"
      @close="resetForm"
    >
      <el-form ref="formRef" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="自理/护理等级" prop="nursingCare">
          <el-input v-model.trim="form.nursingCare" maxlength="50" show-word-limit placeholder="如：自理" />
        </el-form-item>
        <el-form-item label="护理项目" prop="nursingProject">
          <el-input v-model.trim="form.nursingProject" maxlength="50" show-word-limit placeholder="如：自理" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model.trim="form.remark" type="textarea" :rows="3" maxlength="200" show-word-limit />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "LevelCareManage",
  data() {
    return {
      loading: false,
      tableData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      dialogTitle: "新增自理等级",
      submitLoading: false,
      isEdit: false,
      form: {
        id: null,
        nursingCare: "",
        nursingProject: "",
        remark: "",
      },
      rules: {
        nursingCare: [{ required: true, message: "请输入自理/护理等级", trigger: "blur" }],
        nursingProject: [{ required: true, message: "请输入护理项目", trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.loadList();
  },
  methods: {
    tableHeaderStyle() {
      return "text-align:center;font-weight:600;background:#d4f5fa;color:#2d2d2d;";
    },
    groupId() {
      const g = sessionStorage.getItem("groupId");
      return g != null && g !== "" ? Number(g) : null;
    },
    loadList() {
      const gid = this.groupId();
      if (gid == null || isNaN(gid)) {
        this.$message.warning("未获取到机构信息，请重新登录");
        return;
      }
      this.loading = true;
      this.$postJson("omc/levelCare/select", {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        groupId: String(gid),
      })
        .then((res) => {
          if (res && res.code == 200 && res.result) {
            this.tableData = res.result.list || [];
            this.total = Number(res.result.total || 0);
          } else {
            this.tableData = [];
            this.total = 0;
            if (res && res.message) {
              this.$message.error(res.message);
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openAdd() {
      this.isEdit = false;
      this.dialogTitle = "新增自理等级";
      this.resetForm();
      this.dialogVisible = true;
    },
    openEdit(row) {
      this.isEdit = true;
      this.dialogTitle = "编辑自理等级";
      this.form = {
        id: row.id,
        nursingCare: row.nursingCare || "",
        nursingProject: row.nursingProject || "",
        remark: row.remark || "",
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.formRef) this.$refs.formRef.clearValidate();
      });
    },
    resetForm() {
      this.form = {
        id: null,
        nursingCare: "",
        nursingProject: "",
        remark: "",
      };
      if (this.$refs.formRef) this.$refs.formRef.resetFields();
    },
    submitForm() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        const gid = this.groupId();
        if (gid == null || isNaN(gid)) {
          this.$message.warning("未获取到机构信息");
          return;
        }
        this.submitLoading = true;
        const url = this.isEdit ? "omc/levelCare/update" : "omc/levelCare/add";
        const payload = this.isEdit
          ? {
              id: this.form.id,
              groupId: gid,
              nursingCare: this.form.nursingCare,
              nursingProject: this.form.nursingProject,
              remark: this.form.remark,
            }
          : {
              nursingCare: this.form.nursingCare,
              nursingProject: this.form.nursingProject,
              remark: this.form.remark,
              groupId: gid,
            };
        this.$postJson(url, payload)
          .then((res) => {
            if (res && res.code == 200) {
              this.$message.success(res.message || "操作成功");
              this.dialogVisible = false;
              this.loadList();
            } else if (res && res.message) {
              this.$message.error(res.message);
            }
          })
          .finally(() => {
            this.submitLoading = false;
          });
      });
    },
    handleDelete(row) {
      this.$confirm("确定删除该自理等级？若已被费用项、房间或床位引用将无法删除。", "提示", {
        type: "warning",
        closeOnClickModal: false,
      })
        .then(() => {
          this.$postForm("omc/levelCare/delete", { id: row.id }).then((res) => {
            if (res && res.code == 200) {
              this.$message.success(res.message || "删除成功");
              this.loadList();
            } else if (res && res.message) {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.level-care-wrap {
  padding: 0 16px 24px;
  background: #fefefe;
}
.nurse_top {
  border: 1px #f1eff2 solid;
  background: #f9f7fa;
  margin-bottom: 12px;
  img {
    margin: 14px 12px;
  }
}
.toolbar {
  margin-bottom: 12px;
}
.fenye {
  margin-top: 16px;
  text-align: center;
}
</style>
